/**
 * Options for “Service they want”.
 * Keep `value` keys in sync with `SERVICE_LABELS` in `netlify/functions/contact.js` and `api/contact.js`.
 */
export const CONTACT_SERVICE_OPTIONS = [
  { value: '', label: 'Select what you need…' },
  { value: 'custom-platforms', label: 'Custom platforms & product builds' },
  { value: 'modernization', label: 'Modernization & legacy systems' },
  { value: 'ux', label: 'Experience & UX' },
  { value: 'scale', label: 'Scale, performance & architecture' },
  { value: 'deployment', label: 'Cloud / offline / hybrid deployment' },
  { value: 'industry-estate', label: 'Estate, civic, or smart-city software' },
  { value: 'industry-finance', label: 'Accounting, finance, or operations systems' },
  { value: 'industry-sales', label: 'Sales, CRM, or growth tooling' },
  { value: 'other', label: 'Other / not sure yet — let’s figure it out' },
];
